(function () {
    'use strict';
    angular.module('app').controller('CarrierDetailsShareMarginsModalController', CarrierDetailsShareMarginsModalController);
    CarrierDetailsShareMarginsModalController.$inject = [
        'selectedResellers',
        'carrierProfileId',
        '$uibModalInstance',
        'toastr',
        'ServicesService',
        'networkEffects',
        '$q',
        'serviceProfiles'
    ];

    function CarrierDetailsShareMarginsModalController(
        selectedResellers,
        carrierProfileId,
        $uibModalInstance,
        toastr,
        ServicesService,
        networkEffects,
        $q,
        serviceProfiles
    ) {
        const vm = this;
        vm.carrierProfileId = carrierProfileId;
        vm.totalServiceProfiles = serviceProfiles.length;

        vm.margins = [];
        vm.selectedResellers = [];
        vm.sharedResellers = [];
        vm.serviceProfileNetworkEffects = [];
        vm.currentServiceProfileNumber = 0;

        vm.searchMargins = searchMargins;
        vm.closeModal = closeModal;
        vm.save = save;

        init();

        function init() {
            initFrmData(vm.currentServiceProfileNumber);
        }

        function initFrmData(count) {
            const { id, name } = serviceProfiles[count];
            vm.serviceProfileId = id;

            getAllMargins(id).then(data => {
                const margins = data.content;
                vm.selectedResellers = selectedResellers;
                vm.serviceProfileName = name;
                vm.sharedResellersMarginsData = getSelectedMarginsData(margins, selectedResellers);
                vm.isLoading = false;
            }, error => {
                toastr.error('Error', error.message);
                vm.isLoading = false;
            });
        }

        function getAllMargins(serviceProfileId) {
            const deffer = $q.defer();
            vm.isLoading = true;
            ServicesService.getClientServiceLinks(data => {
                deffer.resolve(data);
            }, error => {
                deffer.reject(error);
            }, {
                serviceProfileId: serviceProfileId
            });
            return deffer.promise;
        }

        function getSelectedMarginsData(margins, selectedResellers) {
            const resellers = [];

            for (let i = 0; i < selectedResellers.length; i++) {
                const id = selectedResellers[i].id;
                const foundReseller = networkEffects.find(reseller => reseller.resellers === id);

                if (!foundReseller) {
                    resellers[id] = margins;
                    continue;
                }

                const selectedMargins = getSelectedMargins(foundReseller.clientServiceProfileIds, margins);
                if (selectedMargins) {
                    resellers[id] = selectedMargins;
                }
            }

            return resellers;
        }

        function getSelectedMargins(clientServiceProfileIds, margins) {
            const relatedMargins = [];
            clientServiceProfileIds.forEach(id => {
                const relatedMargin = margins.find(serviceProfileId => serviceProfileId === id);
                if (relatedMargin) {
                    relatedMargins.push(relatedMargin);
                }
            });

            return relatedMargins;
        }

        function searchMargins(searchTerm) {
            ServicesService.getClientServiceLinks(data => {
                vm.margins = data.content;
            }, error => {
                toastr.error('Error', error.message);
            }, {
                serviceProfileId: vm.serviceProfileId,
                name: searchTerm
            });
        }

        function save() {
            vm.serviceProfileNetworkEffects.push(generateNetworkEffectData());
            vm.currentServiceProfileNumber++;

            if (vm.currentServiceProfileNumber < serviceProfiles.length) {
                initFrmData(vm.currentServiceProfileNumber);
                return;
            }
            $uibModalInstance.close(vm.serviceProfileNetworkEffects);
        }

        function generateNetworkEffectData() {
            const resellers = [];
            const resellerIds = Object.keys(vm.sharedResellersMarginsData);

            resellerIds.forEach(data => {
                const margins = vm.sharedResellersMarginsData[data];
                resellers.push({
                    clientServiceProfileIds: margins.map(data => data.id),
                    resellerId: data
                });
            });

            return {
                networkEffects: resellers,
                serviceProfileId: vm.serviceProfileId
            };
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})()



// WEBPACK FOOTER //
// ./js/controllers/modal/CarrierDetailsShareMarginsModalController.js